// extracted by mini-css-extract-plugin
export default {"img":"appointment_img__73vjV","icon":"appointment_icon__Ryx1V"};